function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.107 3.588L6.885.434h3.017L6.895 5.609 10.029 11H7.002L5.117 7.68 3.242 11H.205L3.34 5.61.342.433h3.027l1.738 3.154z",
  fill: "#0785FE"
});

function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none"
  }, props), _ref);
}

export default SvgCloseSmall;